import { cva } from "class-variance-authority";

export const linkVariants = cva('font-medium underline underline-offset-4');